import { combineReducers } from "redux";
import notifications from "./notifications";
import wageDebtors from "./wageDebtors";

const rootReducer = combineReducers({
  notifications,
  wageDebtors,
});

export default rootReducer;
